import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import myImage from '../assets/IMG_3044.JPG';
import phpImg from '../assets/qdJu64px-PHP-logo.svg.png';
import reactImg from '../assets/pyoq64px-React-icon.svg.png';
import mysqlImg from '../assets/rds-mysql-64.png';
import jsImg from '../assets/javascript_original_logo_icon_146455.png';
import '../components/styles.css'
import { Link } from 'react-router-dom';
import ReudxImg from '../projects-img/Redux.png';
import HtmlImg from '../projects-img/html.png';
import CssImg from '../projects-img/css.png';
import GitImg from '../projects-img/git.png';
import downArrow from '../assets/down-arrow.svg';
import Knowledge from './Knowledge';



function Home() {
  return (
    <div className="container-lg">
    <div className="row justify-content-center align-items-center">
        <div className="col-md-9 text-center text-md-start ">
            <div className='content-container container-fluid'>
                <h1 className="display-2 text-light">Junior Full-Stack Developer</h1>
                <p className='text-light'>
                    
                    Welcome to my portfolio website!
                     <br />
                     <br />
                     <br />
                     I'm a junior full-stack developer skilled in JavaScript, PHP, React, Next, MySQL, HTML, CSS, Figma, Bootstrap, Tailwind, Redux, and Git. With a passion for creating seamless web solutions, I strive to deliver exceptional user experiences.
                    <br />
                    <br />
                    In this portfolio, you will find a showcase of my projects, demonstrating my skills in JavaScript, PHP, mySQL, ReactJs, NextJs,Redux, HTML, CSS, Bootstrap and Tailwind. Each project reflects my commitment to delivering intuitive and user-friendly interfaces, while adhering to modern web development best practices.
                    <br />
                    <br />
                    As a continuous learner, I embrace new technologies and frameworks, always seeking to expand my knowledge and stay up-to-date with the latest industry trends. Whether it's building responsive websites, optimizing performance, or integrating interactive elements, I am driven by the challenge of crafting seamless and impactful digital experiences.
                    <br />
                    <br />
                    I invite you to explore my portfolio and discover the projects I have worked on. Feel free to reach out to me for any inquiries or collaboration opportunities. I am excited to embark on new projects and contribute my skills as a Junior Front-End Developer.
                    <br />
                    <br />
                    Thank you for visiting, and I look forward to connecting with you!
                    <br />
                    <br />
                    Mehmet Govori, Junior Full-Stack Developer
                </p>
            <Link to="/Projects"  className="d-block mt-3"  >Explore my projects</Link>
            </div>
        </div>
        <div className="col-md-3 text-center d-none d-md-block">
           <span className="tip" data-bs-placement="bottom" title="My Picture">
              <img className="img-fluid rounded-2 flipping-image" src={myImage} alt="My pic" />
           </span>
        </div>

    </div>

    <section className="container-fluid ms-4">
  <h1 className="display-5 text-light text-center pt-4">Coding Skills <img className="arrow" src={downArrow} alt="" /></h1>
  <div className="list-content">
  <ul className="row justify-content-between align-items-end my-5 list-unstyled ms-5">
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-2">
        <span>ReactJs</span>
        <img className="img-fluid" src={reactImg} alt="" />
      </div>
    </li>
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-0">
        <span>Redux</span>
        <img className="img-fluid" src={ReudxImg} alt="" />
      </div>
    </li>
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-11">
        <span>JavaScript</span>
        <img className="img-fluid" src={jsImg} alt="" />
      </div>
    </li>
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-3">
        <span>PHP</span>
        <img className="img-fluid mb-2" src={phpImg} alt="" />
      </div>
    </li>
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-0">
        <span>MySQL</span>
        <img className="img-fluid" src={mysqlImg} alt="" />
      </div>
    </li>
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-0">
        <span>HTML</span>
        <img className="img-fluid" src={HtmlImg} alt="" />
      </div>
    </li>
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-0">
        <span>CSS</span>
        <img className="img-fluid" src={CssImg} alt="" />
      </div>
    </li>
    <li className="col-lg-3 col-md-4 col-sm-6 col-12 text-light fs-2 d-flex align-items-center">
      <div className="d-grid gap-0">
        <span>Git</span>
        <img className="img-fluid" src={GitImg} alt="" />
      </div>
    </li>
  </ul>
  </div>
</section>

<Knowledge/>






</div>
  )
}

export default Home